export enum InstallationMethod {
  PowerShell = "powershell",
  Msi = "msi",
}
